import { render } from "./icon-user.vue?vue&type=template&id=1545d01c"
import script from "./icon-user.vue?vue&type=script&lang=js"
export * from "./icon-user.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__